import React, { memo } from 'react';
import { Row, Col, Typography, Table } from 'antd';
import moment from 'moment';

const { Text } = Typography;

interface Props {
    issueDetails?: any
}

const IssueTrackerDiagnosticCard: React.FC<Props> = memo(({ issueDetails }) => {

    const showLegacy = !!(issueDetails?.diagnosis || issueDetails?.overall_summary)
    const diagnosisNotes = Array.isArray(issueDetails?.diagnosis_notes) ? issueDetails.diagnosis_notes : []

    const noteColumns = [
        {
            title: 'Created Date',
            dataIndex: 'created_on',
            key: 'created_on',
            width: '22%',
            render: (ts: number) => (ts ? moment(ts).format('MM/DD/YYYY HH:mm:ss') : '—')
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (text: string) => <span style={{ whiteSpace: 'pre-wrap' }}>{text || '—'}</span>
        }
    ]

    return (
        <>
                <Row>
                    <Col span={24}>
                        <div className='W-100'>
                            <p style={{ fontSize: "16px", fontWeight: 500 }} className='mb-4'>
                                Diagnosis Details
                            </p>
                            {showLegacy && (
                            <div className='p-1 mb-3' style={{ background: '#fafafa', borderRadius: 8 }}>
                            {issueDetails?.diagnosis ? (
                            <p className="paragraph mb-3">
                            <p style={{ fontSize: "13px", fontWeight: 5 }}>
                                Diagnosis
                            </p>
                                    <Text className="mr-1 mb-0">
                                        {issueDetails?.diagnosis}
                                    </Text>
                            </p>
                            ) : null}
                            {issueDetails?.overall_summary ? (
                            <p className="paragraph">
                            <p style={{ fontSize: "13px", fontWeight: 5 }}>
                                Overall Summary
                            </p>
                                    <Text className="mr-1 mb-0">
                                        {issueDetails?.overall_summary}
                                    </Text>
                            </p>
                            ) : null}
                            </div>
                            )}
                            <div className="p-1">
                                <Table
                                    columns={noteColumns as any}
                                    dataSource={diagnosisNotes.map((n: any) => ({ ...n, key: n.id }))}
                                    pagination={false}
                                    size="small"
                                    locale={{ emptyText: 'No diagnosis notes' }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>

        </>
    );
})
export default IssueTrackerDiagnosticCard;
